/**
 *
 * @param {string} name
 * @param {string} origin
 * @param {Schema.SalesAgent|undefined} agent
 * @param {{ url: string|URL, referrer?: string, props?: Object<string, any>, revenue?: Schema.Money }} params
 */
export function track(name, origin, agent, params) {
  const url = new URL(params.url, origin)
  if (agent && !url.searchParams.has('utm_source')) {
    url.searchParams.set('utm_source', agent.uid)
  }

  return fetch(new URL('/stats/event', origin), {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      referrer: window.location.href,
      ...params,
      url,
      name,
      domain: `allaboard.eu,${agent?.uid}.allaboard.eu`
    })
  })
}

export function getSessionId() {
  const match = document.cookie.match(/(?:^|;\s*)aa.session=(.+?)(?:;|$)/)
  if (match) return match[1]

  const sessionId =
    typeof globalThis !== 'undefined' &&
    typeof globalThis?.crypto?.randomUUID === 'function'
      ? globalThis.crypto.randomUUID()
      : Math.random().toString(36).substring(2)

  document.cookie = `aa.session=${sessionId}; path=/; samesite=lax; secure`

  return sessionId
}
